import script from "./ProductSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSearch.vue?vue&type=script&setup=true&lang=js"

import "./ProductSearch.vue?vue&type=style&index=0&id=27503a25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27503a25"]])

export default __exports__